import React, { useEffect, useMemo, useState } from 'react';
import {
  Aggregate,
  AggregateColumnDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
} from '@syncfusion/ej2-react-grids';
import { Box, Typography } from '@material-ui/core';
import { IconButton } from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
function camelCaseToLabel(text) {
  return text
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter
}
const SyncfusionDataTable = ({
  columns,
  data,
  sectionName,
  handelSiteInfoEdit,
  headerUI,
  canDeleteRowSections,
  deletefnc,
  minWidth,
  isContractCreated,
}) => {
  const editOptions = { allowEditing: true, mode: 'Dialog' };

  const [siteSectionData, setSiteSectionData] = useState([]);
  useEffect(() => {
    console.log(data, sectionName);
    setSiteSectionData(data);
  }, [data]);
  const handleRowDoubleClick = props => {
    if (!isContractCreated) {
      handelSiteInfoEdit(sectionName, props.rowData);
    }
  };
  const deleteTemplate = rowData => {
    if (isContractCreated) {
      return null;
    }

    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <IconButton color="error" onClick={deletefnc ? () => deletefnc(rowData, sectionName) : () => {}}>
          <DeleteRoundedIcon />
        </IconButton>
      </div>
    );
  };
  const linkTemplate = (rowData, name) => {
    return rowData[name] ? (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <a href={`${rowData[name]}`} target="_blank" rel="noreferrer">
          Link
        </a>
      </div>
    ) : (
      ''
    );
  };

  const totalTemplate = props => {
    const total = parseFloat(props?.Sum ?? 0);
    return `${total.toFixed(2)}`;
  };

  const renderAggregateColumns = () => {
    if (sectionName !== 'Site Volume (Consolidated)' || !Array.isArray(siteSectionData) || siteSectionData.length === 0)
      return null;

    const firstRow = siteSectionData[0];

    return (
      <AggregatesDirective>
        <AggregateDirective>
          <AggregateColumnsDirective>
            {columns
              .filter(col => {
                if (!col?.key) return false;
                const value = firstRow[col.key];
                return typeof value === 'number' && !isNaN(value);
              })
              .map((col, index) => (
                <AggregateColumnDirective
                  key={`agg_${col.key}_${index}`}
                  field={col.key}
                  type="Sum"
                  format="N2"
                  footerTemplate={totalTemplate}
                />
              ))}
          </AggregateColumnsDirective>
        </AggregateDirective>
      </AggregatesDirective>
    );
  };

  return (
    <Box
      component={'div'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        borderRadius: '0.5rem',
      }}>
      <Typography variant="h3" style={{ paddingBottom: '.25rem', textTransform: 'capitalize' }}>
        {camelCaseToLabel(sectionName)}{' '}
        {isContractCreated
          ? sectionName === 'geolocations'
            ? React.Children.toArray(headerUI.props.children).filter(
                child => child.props?.children === 'Show Map' || child.props?.children === 'Show Route Map',
              )
            : null
          : headerUI}
      </Typography>

      <div style={{ overflow: 'auto', height: '100%', width: '100%', borderRadius: 'inherit' }}>
        <GridComponent
          dataSource={siteSectionData}
          allowTextWrap={true}
          style={{
            minHeight: 'auto !important',
            minWidth: minWidth || 'auto',
          }}
          recordDoubleClick={handleRowDoubleClick}
          key={siteSectionData ? siteSectionData.length : 0}>
          <ColumnsDirective>
            {columns.map((column, index) =>
              column.link ? (
                <ColumnDirective
                  field={column.key}
                  headerText={column.label}
                  width={column.width || 'auto'}
                  key={`${column.key}_${sectionName}_${index}`}
                  visible={column.hidden ? false : true}
                  isPrimaryKey={column?.primaryKey}
                  template={props => linkTemplate(props, column.key)}
                />
              ) : (
                <ColumnDirective
                  field={column.key}
                  headerText={column.label}
                  width={column.width || 'auto'}
                  key={`${column.key}_${sectionName}_${index}`}
                  visible={column.hidden ? false : true}
                  isPrimaryKey={column?.primaryKey}
                />
              ),
            )}
            {canDeleteRowSections && (
              <ColumnDirective textAlign="Center" headerText="Action" width={80} template={deleteTemplate} />
            )}
          </ColumnsDirective>

          {renderAggregateColumns()}

          <Inject services={[Aggregate]} />
        </GridComponent>
      </div>
    </Box>
  );
};

export default SyncfusionDataTable;
